import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MenuItemTemplates, SgNavItemDefContext } from './interfaces';
import { NavGroup, NavItemType } from './models';

/**
 * A helper function to run a sort on the navigation tree to reflect explicit 'ordinal' configuration.
 * @param items
 * @param deep Sort children
 * @returns {Array<NavItemType>}
 */
function sortTree(items: NavItemType[], deep: boolean): NavItemType[] {
  const group = new NavGroup();
  group.children = items;
  return group.sort(deep).children;
}

@Injectable()
export class SgNavMenuService implements MenuItemTemplates {
  itemLink: TemplateRef<SgNavItemDefContext>;
  menuTree$: Observable<NavItemType[]>;
  totalNotificationNum$ = new BehaviorSubject<number>(0);
  activeMenuItem$ = new BehaviorSubject<NavItemType>(null);
  notificationClick$ = new Subject<Event | null>();
  private menuTree = new BehaviorSubject<NavItemType[]>([]);

  constructor() {
    this.menuTree$ = this.menuTree.asObservable();
  }

  addRootNavItem(...mi: NavItemType[]): void {
    let menuTree: NavItemType[] = sortTree(mi, true);
    // sort the top level shallow, the old one's does not need deep inspection.
    menuTree = sortTree(this.menuTree.getValue().concat(menuTree), false);
    this.menuTree.next(menuTree);
  }

  /**
   * Same as `addRootNavItem` but filter duplicates / existing
   */
  addRootNavItems(menuItems: NavItemType[]): void {
    this.addRootNavItem(...menuItems.filter((mi) => !this.hasRootNavItem(mi)));
  }

  hasRootNavItem(item: NavItemType): boolean {
    const itemUrl = item.url;
    return this.menuTree.getValue().some((mi) => mi.url === itemUrl);
  }

  initRootNavItems(menuItems: NavItemType[]): void {
    let menuTree: NavItemType[] = sortTree(menuItems, true);
    this.menuTree.next(menuTree);
  }

  /**
   * Emits the same menu tree again.
   * Use this to workaround CD issues when the init is deferred, for example deferring due to async route guards.
   */
  sync(): void {
    this.menuTree.next(this.menuTree.value);
  }
}
